<template>
  <b-modal id="photograph" size="xl" content centered ok-only>
    <template v-slot:modal-header>
      <div class="header">
        <!-- <div class="header_icon">
          <b-icon icon="camera-fill"></b-icon>
        </div> -->
        <div class="content">
          <h3>Thuy's gallery</h3>
          <p style="font-style: italic">
            I travel and I take photos. Click and explore!
          </p>
        </div>
        <b-button @click="closeModal" class="close-btn">
          <b-icon-x aria-label="Close"></b-icon-x>
        </b-button>
      </div>
    </template>
    <b-card-group columns>
      <div v-for="(photo, i) in photos" :key="i">
        <b-card no-body :img-src="photo.image" img-top @click="show(i)" class="photo_in_gird">
        </b-card>
      </div>
    </b-card-group>
    <b-modal id="showDetail" size="xl" centered modal-class="photo" hide-footer>
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="8" order-lg="2" order="2" style="padding: 0" class="photo_big">
            <div>
              <b-img :src="photos[index].image" fluid></b-img>
            </div>
            <b-button class="left"><b-icon icon="chevron-double-left" @click="left()"
                :disabled="disabledLeft" /></b-button>
            <b-button class="right"><b-icon icon="chevron-double-right" @click="right()"
                :disabled="disabledRight" /></b-button>
          </b-col>
          <b-col cols="12" lg="4" order-lg="2" order="1">
            <b-row class="author">
              <b-col cols="2" style="padding-right: 0">
                <div>
                  <b-img fluid :src="author" style="border-radius: 50%"></b-img>
                </div>
              </b-col>
              <b-col cols="10">
                <div>
                  <h4>thuy.le.soleil</h4>
                </div>
              </b-col>
            </b-row>
            <div style="margin-top: 16px">
              <p>{{ photos[index].description }}</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      disabledLeft: false,
      disabledRight: false,
      index: 0,
      photos: [
        {
          image: require('../assets/photograph/inle_lake.jpg'),
          description: 'I took this photo on Inle Lake in Myanmar early one morning. It was quite chilly, and I was out in the middle of the vast lake.',
        },
        {
          image: require('../assets/photograph/yagon_old_building.jpg'),
          description: 'One of Yangon’s charms is its old buildings on almost every street corner.',
        },
        {
          image: require('../assets/photograph/three_birds.jpg'),
          description: 'Seagulls love throwing a party on the beach. I captured this moment on a freezing day at Haeundae Beach in Busan, South Korea.',
        },
        {
          image: require('../assets/photograph/the_man_with_the_dog.jpg'),
          description: 'This man and his dog were sitting there, looking out at one of Japan’s most beautiful castles—and I happened to be there too.',
        },
        {
          image: require('../assets/photograph/osaka.jpg'),
          description: 'When I started learning Japanese, I’d always wanted to visit Osaka Castle.',
        },
        {
          image: require('../assets/photograph/shirakawago.jpg'),
          description: 'The 5 am train from Tokyo took me to Shirakawa on New Year\'s Day. The views on both sides of the road were breathtaking.',
        },
        {
          image: require('../assets/photograph/shirakawago_house.jpg'),
          description: 'I was wandering through Shirakawa, visiting traditional Japanese houses. It felt like I’d stepped into the film "Seven Samurai".',
        },
        {
          image: require('../assets/photograph/bagan.jpg'),
          description: 'I arrived in Bagan, Myanmar, at 4 a.m. and sat at a temple waiting for this moment. It was worth the long night bus ride!',
        },
        {
          image: require('../assets/photograph/phu_yen_beach.jpg'),
          description: 'This gorgeous sandy beach, Bai Goc, is one of my favourite beaches in Vietnam.',
        },
        {
          image: require('../assets/photograph/phu_yen_light_house_beach.jpg'),
          description: 'Another gorgeous hidden sandy beach in Phu Yen - check it out! It\'s called Bãi Môn',
        },
        {
          image: require('../assets/photograph/anapji_pond.jpg'),
          description: 'It was a freezing night in Gyeongju. I was walking around Anapji pond, which looked like a vast mirror reflecting beautiful buildings of Donggung Palace.',
        },
        {
          image: require('../assets/photograph/taipei.jpg'),
          description: 'This is Taipei from Elephant mountain. Before taking this picture, I\'d climbed the stairs to the top twice. It was a hot, humid afternoon, but it worth it!',
        },
        {
          image: require('../assets/photograph/sigiriya.jpg'),
          description: 'Sigiriya is one of the most touristy places in Sri Lanka. I did\'nt climb the main rock; instead, I climbed a nearby one and got an amazing view. There were lots of dogs around, and they were excellent climbers!',
        },
        {
          image: require('../assets/photograph/flowers.jpg'),
          description: 'I took this photo when walking around a temple in Chiang Mai, Thailand. I can\'t remember its name. I just remember a beautiful garden with lots of dogs sleeping under the trees!',
        },
        {
          image: require('../assets/photograph/luang_prabang.jpg'),
          description: 'It was late afternoon when I arrived in Luang Prabang. This is the sunset over the Mekong river, and I am a big fan of sunsets!',
        },
        {
          image: require('../assets/photograph/angkor_2.jpg'),
          description: 'I was in awe when the sun came out, and Angkor Wat appeared before my eyes. It\'s hard to find the right words to describe this incredible temple complex',
        },
        {
          image: require('../assets/photograph/angkor_3.jpg'),
          description: 'This is a part of Ta Prohm, located about one kilometer east of Angkor Thom in Siem Reap, Cambodia.',
        },
        {
          image: require('../assets/photograph/eliya.jpg'),
          description: 'On the way to Hortain Plain in Nuwara Eliya, Sri Lanka, I passed this farm. Nuwara Eliya is famous for tea, and the weather here feels like England - it changes all the time!',
        },
        {
          image: require('../assets/photograph/ubud.jpg'),
          description: 'Early morning in Mount Batur in Bali, Indonesia. I got up at 2 am and started climbing this inactive volcano at 3 am. The moon was high above us, the slippery lava rocks made the hide tough, but I was so excited to see the sunrise that I kept going.',
        },
        {
          image: require('../assets/photograph/henderson_bridge.jpg'),
          description: 'My favourite spot in Singapore is Henderson Waves Bridge!',
        },
        {
          image: require('../assets/photograph/glass_n_lights.jpg'),
          description: 'I don\'t just take photos when travelling. I also enjoy spending a day taking pictures at home.',
        },
      ],
      author: require('../assets/photograph/thuy.jpg'),
    }
  },
  methods: {
    show(i) {
      this.index = i
      this.$bvModal.show('showDetail')
    },
    left() {
      if (this.index > 0) {
        return this.index--
      }
      this.disabledLeft = true
    },
    right() {
      if (this.index === this.photos.length - 1) {
        this.disabledRight = true
      }
      this.index++
    },
    closeModal() {
      this.$bvModal.hide('photograph')
    }
  },
}
</script>

<style scoped lang="scss">
@import "../styles/components/Photograph.scss";
</style>
